import * as React from "react";

const MOBILE_BREAKPOINT = 768;

/**
 * A stable hook to detect mobile screen size
 */
export function useIsMobile() {
  // Initialize with server-safe default, then update in effect
  const [isMobile, setIsMobile] = React.useState<boolean>(false);

  React.useEffect(() => {
    // Function to check if we're on mobile
    const checkMobile = () => {
      return window.innerWidth < MOBILE_BREAKPOINT;
    };

    // Set initial state immediately
    setIsMobile(checkMobile());

    // Handler for resize events
    const handleResize = () => {
      const newIsMobile = checkMobile();
      setIsMobile(newIsMobile);
    };

    // Add resize listener
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobile;
}
